import { type FC } from 'react';

import { type ClickOrPressEvent } from 'types/mouseEvents';

export const PAGINATION_SELECTED_CLASSNAME = 'pagination-selected';


export interface PageViewProps {
    className?: string;
    selected: boolean;
    page: number;
    queryParamPage?: string;
    onClick: (event: ClickOrPressEvent) => void;
    serverPageUrl?: string;
}

const PageView: FC<PageViewProps> = ({
    className = '',
    selected = false,
    page = 0,
    queryParamPage = 'page',
    onClick,
    serverPageUrl,
}) => {
    const pageClass = selected
        ? `${className} ${PAGINATION_SELECTED_CLASSNAME}`
        : className;

    let url = (typeof window !== 'undefined')
        ? `${window.location.href.split('?')[0]}?${queryParamPage}=${page}`
        : '';

    if (typeof window === 'undefined' && serverPageUrl) {
        url = `${serverPageUrl.split('?')[0]}?${queryParamPage}=${page}`;
    }

    return (
        <div className={`pagination-item pagination-item-page ${pageClass}`}>
            <a href={url} onClick={onClick} className="pagination-item-content">
                {page}
            </a>
        </div>
    );
};

export default PageView;
